export default __webpack_public_path__ + "static/media/Who_is_Animus.5719991e.mp4";